// features/licenses/licenseSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

export const fetchHistory = createAsyncThunk(
    'History/fetchHistory',
    async () => {
        const res = await axios.get(
            `${process.env.REACT_APP_API_URL}/api/history`,
            {
          headers: {
              'Authorization': 'Bearer ' + localStorage.getItem('token'),
          },
            }
        );
        res.data.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));
        return res.data;
    }
);

const HistorySlice = createSlice({
  name: 'History',
  initialState: {
      history: {
        data: [],
        loading: false,
        error: null,
      },
    },
  reducers: {},
   extraReducers: (builder) => {
    // FETCH LICENSES
    builder
      .addCase(fetchHistory.pending, (state) => {
        state.history.loading = true;
      })
      .addCase(fetchHistory.fulfilled, (state, action) => {
        state.history.loading = false;
        state.history.data = action.payload;
      })
      .addCase(fetchHistory.rejected, (state, action) => {
        state.history.loading = false;
        state.history.error = action.error.message;
      });
  },
});

export default HistorySlice.reducer;
